import { FC } from 'react';
import { QueryClient, QueryClientProvider } from 'react-query';
import { ReactQueryDevtools } from 'react-query/devtools';
import { Router } from 'Router';
import { styleTheme } from './styleTheme';
import { Notification } from 'components/Notification';
import { AppPreloader } from 'components/AppPreloader';
import { ThemeProvider } from '@material-ui/core/styles';
import { AppProvider } from 'components/AppProvider';
import { SnackbarProvider } from 'notistack';
import { RootStoreProvider } from './RootStore';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      structuralSharing: false,
      refetchOnWindowFocus: false,
      retry: false,
      //refetchOnmount: false,
      //refetchOnReconnect: false,
      //retry: false,
    },
  },
});

const App: FC = () => (
  <SnackbarProvider maxSnack={3}>
    <QueryClientProvider client={queryClient}>
      <RootStoreProvider>
        <Notification>
          <ThemeProvider theme={styleTheme}>
            <AppProvider>
              <Router />
            </AppProvider>
            <AppPreloader />
          </ThemeProvider>
        </Notification>
      </RootStoreProvider>
      <ReactQueryDevtools />
    </QueryClientProvider>
  </SnackbarProvider>
);

export default App;
